import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Button, Col, Form, notification, Row, Upload } from "antd";
import { MdOutlineFileUpload } from "react-icons/md";
import { getLanding, updateLanding } from "../../../../api/landing";
import { useSelector } from "react-redux";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../config/firebase"; 


const Landing = () => {
  const [form] = Form.useForm();
  const videoRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [mediaFile, setMediaFile] = useState(null);
  const [mediaError, setMediaError] = useState("");
  const [videoURL, setVideoURL] = useState(null);

  const landingData = useSelector((state) => state.landing.data);

  const captureThumbnail = () => {
    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.filter = "blur(10px)"; // Apply blur effect
    ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/png");
  };

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl?.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr?.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr?.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const thumbnailDataURL = captureThumbnail();
      const thumbnailBlob = dataURLtoBlob(thumbnailDataURL);

      const storageRef = ref(storage, `thumbnails/${mediaFile.name}_thumbnail.png`);
      await uploadBytes(storageRef, thumbnailBlob);
      const thumbnailURL = await getDownloadURL(storageRef);

      const success = await updateLanding({
        media: values?.media?.file?.originFileObj,
        thumbnailURL: thumbnailURL ? thumbnailURL : null,
        mediaType : values?.mediaType,
      });
      if (success) {
        await getLanding();
        notification.success({
          message: "Success",
          description: "Landing page updated successfully!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while updating the landing page.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (landingData && landingData?.landingVideo) {
      setVideoURL(landingData?.landingVideo);
    }
  }, [landingData]);

  const beforeUpload = (file) => {
    const allowedTypes = ["video/mp4", "video/webm"];
    const isAllowed = allowedTypes.includes(file?.type);
    if (!isAllowed) {
      setMediaError("Invalid file type. Please upload an video.");
    } else {
      setMediaFile(file);
      setMediaError("");
    }
    return isAllowed ? true : Upload.LIST_IGNORE;
  };

  return (
    <div className="blog_tab_container">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        autoComplete="off"
      >
        <Row gutter={[20, 0]}>
          <Col xs={24}>
            <Row gutter={[20, 0]}>
              <Col xs={24} md={7}>
                <Form.Item
                  label=""
                  name="media"
                  validateStatus={mediaError ? "error" : ""}
                  help={mediaError}
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Upload.Dragger
                    beforeUpload={beforeUpload}
                    maxCount={1}
                    fileList={[]}
                    showUploadList={false}
                    className="upload_media"
                  >
                    <p>
                      <MdOutlineFileUpload
                        size={30}
                        style={{ marginBottom: "6px" }}
                      />
                    </p>
                    <p>Click or drag file to this area to upload</p>
                  </Upload.Dragger>
                </Form.Item>
              </Col>
              <Col xs={24} md={7}>
                {mediaFile && mediaFile?.type?.startsWith("video/") && (
                  <video controls ref={videoRef} className="preview_video">
                    <source
                      src={URL.createObjectURL(mediaFile)}
                      type={mediaFile?.type}
                    />
                    Your browser does not support the video tag.
                  </video>
                )}
                {!mediaFile && videoURL && videoURL && (
                  <video controls className="preview_video">
                    <source src={videoURL} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                {videoRef?.current && (
                  <img
                    src={captureThumbnail()}
                    alt="Thumbnail"
                    className="thumbnail"
                  />
                )}
              </Col>
            </Row>
          </Col>

          <Col xs={24}>
            <Button
              className="button"
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "200px", marginTop: "10px", height: "37px" }}
            >
              SAVE
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Landing;